import { useEffect, useState } from 'react';
import Proptypes from 'prop-types';
import { connect, useDispatch, useSelector } from 'react-redux';

import { getAlmacenesAction } from '../../redux/actions/almacen.action';
import {
  patchRecepcionarGuiaAction,
  patchDevolverGuiaAction,
} from '../../redux/actions/guia.action';
import { confirmacion } from '../../commons/Mensajes';
import { formatoMonetario } from '../../commons/Utilitarios';

import Modal from '../../commons/Modal';
import Texto from '../../commons/Texto';
import Tabla from '../../commons/Tabla';
import Combo from '../../commons/Combo';

import SaveIcon from '@material-ui/icons/Save';
import Boton from '../../commons/Boton';

const GuiaRecepcionar = ({
  selected,
  processing,
  errors,
  devolution,
  onClose,
}) => {
  const dispatch = useDispatch();

  const [store, setStore] = useState('');

  const { tiposTraslados } = useSelector((state) => state.detalle);
  const { almacenes } = useSelector((state) => state.almacen);

  useEffect(() => {
    if (selected.gui.sl) {
      dispatch(
        getAlmacenesAction({
          cs: devolution ? selected.gui.sp : selected.gui.sl,
        }),
      );
    }
    return () => {
      onClose();
    };
  }, []);

  const columnsLots = [
    {
      key: 'lt',
      align: 'center',
      label: 'Lote',
    },
    {
      key: 'co',
      align: 'center',
      label: 'Orden compra',
    },
    {
      key: 'pc',
      align: 'center',
      label: 'Precio compra',
      content: (item) =>
        `${item.tm === 0 ? 'PEN' : 'USD'} ${formatoMonetario(item.pc)}`,
    },
    {
      key: 'us',
      align: 'center',
      label: 'Solicitadas',
    },
  ];

  const columns = [
    {
      key: 'nm',
      label: 'Producto',
    },
    {
      key: 'um',
      align: 'center',
      label: 'Unidad medida',
    },
    {
      key: 'un',
      align: 'center',
      label: 'Cantidad',
    },
    {
      key: 'pb',
      align: 'center',
      label: 'Peso',
    },
    {
      key: 'lts',
      align: 'center',
      label: 'Lotes',
      content: (item) => (
        <div className="op-centrar-componentes">
          <Tabla
            columns={columnsLots}
            data={item.lts.filter((f) => f.us !== 0)}
            hoverSelectedRow={false}
            searcheable={false}
            pagination={false}
            style={{ padding: '0px' }}
          />
        </div>
      ),
    },
  ];

  return (
    <>
      <Modal
        title={`${devolution ? 'Devolver' : 'Recepcionar'} Guía - ${selected.nd}`}
        processing={processing}
        loading="files"
        onActions={() => (
          <>
            <Boton
              className="op-dinamic"
              disabled={processing}
              icon={() => <SaveIcon />}
              tabIndex={19}
              style={{ '--button-color': '#1ab394' }}
              onClick={() =>
                confirmacion(
                  '¿Está seguro?',
                  `De ${devolution ? 'devolver' : 'recepcionar'} la guía de remisión`,
                )
                  .then(() => {
                    if (devolution) {
                      dispatch(patchDevolverGuiaAction(selected.dc, store));
                    } else {
                      dispatch(patchRecepcionarGuiaAction(selected.dc, store));
                    }
                  })
                  .catch(() => {})
              }
            >
              {devolution ? 'Devolver' : 'Recepcionar'}
            </Boton>
          </>
        )}
        onClose={() => onClose()}
      >
        <Texto
          name="pp"
          value={selected.gui.pp}
          label="Origen"
          size={3}
          tabIndex={10}
          onChange={() => {}}
          disabled
        />
        {selected.gui.mt && tiposTraslados.find((t) => t.vm === 'TRAMTT') && (
          <>
            <Texto
              name="ll"
              value={devolution ? selected.gui.pp : selected.gui.ll}
              label="Destino"
              size={3}
              tabIndex={11}
              onChange={() => {}}
              disabled
            />
            <Combo
              name="sll"
              value={store}
              label="Almacen"
              size={3}
              tabIndex={3}
              data={almacenes.map((i) => ({
                value: i.al,
                label: i.na,
              }))}
              error={errors?.al}
              onChange={({ value }) => setStore(value)}
            />
          </>
        )}
        {devolution && (
          <>
            <span>
              Al procesar una devolución, el sistema retornará por defecto la
              totalidad de los productos al almacén seleccionado.
            </span>
            <span>
              <span class="alerta">Importante:</span> Si recibe una cantidad
              menor a la enviada originalmente, deberá justificar los productos
              faltantes de forma manual.
            </span>
            <span>
              <strong>¿Cómo registrar la diferencia?</strong>
            </span>
            <ol>
              <li>
                Ingrese al menú de <span class="resaltado">Inventarios</span>.
              </li>
              <li>
                Haga clic en el botón{' '}
                <span class="resaltado">Registrar movimiento</span>.
              </li>
              <li>
                Registre los productos faltantes seleccionando el concepto
                adecuado (pérdida, merma o el que mejor se adapte a la
                situación).
              </li>
            </ol>
          </>
        )}
        <div className="op-form-group op-col-1 view-ordencompra">
          <Tabla
            columns={columns}
            data={selected.gui.dtl}
            pagination={false}
            searcheable={false}
            hoverSelectedRow={false}
            style={{ padding: '0px' }}
          />
        </div>
      </Modal>
    </>
  );
};

GuiaRecepcionar.propTypes = {
  devolution: Proptypes.bool,
  onClose: Proptypes.func.isRequired,
};

GuiaRecepcionar.defaultProps = {
  devolution: false,
};

const mapStateToProps = (state) => {
  return {
    selected: state.guia.selected,
    processing: state.guia.processing,
    errors: state.guia.errors,
  };
};

export default connect(mapStateToProps)(GuiaRecepcionar);
